import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Carousel, Container } from '@pella/sash-framework';
import { CTA } from '../../../';
import { isValidArray } from '../../../utilities/validations';

import CardRenderer from '../../../common/card-types/card-renderer';

const ProjectCarousel = ({ data, projects, className, ...other }) => {
	if (!isValidArray(projects)) return null;

	return (
		<div
			className={`projectCarousel relative overflow-hidden py-8 md:py-[42px] xl:py-[52px] ${className || ''}`}
			style={data?.background_hex_value ? { backgroundColor: data.background_hex_value } : null}
			data-testid='project-carousel'
			{...other}
		>
			<Container>
				<div className='md:flex md:flex-row md:items-center md:justify-between'>
					{data?.heading && <h2 className='text-h3 mb-2 md:mb-0'>{data.heading}</h2>}
					{isValidArray(data?.cta) && projects?.length > 3 && (
						<CTA
							data={data.cta[0]}
							className='!justify-start'
						/>
					)}
				</div>
			</Container>

			<Container noPadding>
				<Carousel
					className={`py-6 before:z-2 after:z-2 max-md:scroll-px-6 max-md:px-6 max-md:before:content-none max-md:after:content-none xl:py-8 ${data.background_hex_value === '#F2F2F2' ? 'before:from-neutral-50 after:from-neutral-50' : 'before:from-white after:from-white'}`}
					dotsClassName='!mt-0'
					arrowsClassName='[&>li:first-child>button]:left-5 [&>li:last-child>button]:right-5'
					slidesToShow={{ xs: 1, sm: 1.5, md: 2.25, xl: 3 }}
					slidePadding={16}
					showSlideHints
					showArrows
					showDots
				>
					{projects.map((project, index) => {
						const cardDescription = project.top_content?.subheading || project.seo?.description;

						return (
							<CardRenderer
								key={index}
								data={{
									card_type: 'standard',
									variant: 'standard-padded-content',
									image: project?.modular_blocks?.find((block) => block.all_images != null)?.all_images?.image,
									ctas: [{ link: { href: project.url }, aria: project.top_content?.heading }],
									heading: project.top_content?.heading,
									description: cardDescription?.length > 80 ? cardDescription?.substring(0, 80) + '...' : cardDescription,
									seo_tag: project.top_content?.heading,
								}}
								showCtas={false}
							>
								{project.taxonomies?.find((tag) => tag.term_uid === 'featured_article') && (
									<Badge
										color='primary'
										className='absolute left-0 top-0'
									>
										Featured
									</Badge>
								)}
							</CardRenderer>
						);
					})}
				</Carousel>
			</Container>
		</div>
	);
};

ProjectCarousel.propTypes = {
	data: PropTypes.object,
	projects: PropTypes.array,
	className: PropTypes.string,
};

export default ProjectCarousel;
